import * as ui from './ui.js';
import * as events from './events.js'
import * as spotify from '../services/spotify.js'
import * as appleMusic from '../services/apple-music.js'
import * as tidal from '../services/tidal.js'
import * as youtube from '../services/youtube.js';
import { clearSessions } from './auth.js';
import { truncate } from './formatting.js';
import '../components/player.js';

let sonikit, apiPlayer;

class Player {
  constructor(service, player_type) {
    this.tracklist = null;
    this.currentTrack = {
      id: '',
      artist: '',
      title: '',
      image_url: ''
    }

    this.deviceId = null;
    this.state = null;
    this.muted = false;
    this.access_token = null;
    this.service = service;
    this.player_type = player_type;
    this.user_interacted = false;
    this.track_change_method = 'queued';
  }

  setDeviceId(id) {
    this.deviceId = id;
  }

  setState(state) {
    this.state = state;

    if (state === 'paused') {
      streamTimer.pause();
    } else if (state === 'playing') {
      streamTimer.resume();
    } else if (state === 'ended') {
      streamTimer.pause();
      if (this.player_type === 'station') {
        sonikit.emit('streamEnded');
        this.disconnect();
      }
    } else {
      console.log(state)
    }
    
    sonikit.emit('playerStateChanged', { state });
  }

  reset() {
    this.service = null;
  }

  updateTrack(new_track) {
    if (this.tracklist) {
      const current_index = this.tracklist.findIndex(x => x.id === this.currentTrack.id);

      if (current_index === this.tracklist.length - 1) {
        //console.log('this is the last track')
      }

      const new_index = this.tracklist.findIndex(x => x.id === new_track.id);
      if (new_index === -1) {
        this.pause()
        
        if (this.player_type === 'station') {
          sonikit.emit('streamEnded');
          this.disconnect()
        }
        return
      }
    }


  
    if (this.track_change_method === 'auto' && this.patch.project === '660755d67afa33f3c38c2e9c') {
      this.stopContinousPlay();
    }
    

    this.track_change_method = 'auto'


    this.currentTrack = new_track;

    sonikit.emit('playerTrackChanged', { 
      image_url: new_track.image_url,
      title: truncate(new_track.title, 20),
      artist: truncate(new_track.artist, 20)
    });
  }

  startTimer() {
    streamTimer.start();
  }

  togglePlayback() {
    if (this.service.name === 'sonikit' || this.service.name === 'qobuz') {
      if (apiPlayer.paused) {
        apiPlayer.play();
      } else {
        apiPlayer.pause();
      }
    } else if (this.service.name === 'spotify') { 
      apiPlayer.getCurrentState().then(state => {
        if (!state) {
          return
        }

        apiPlayer.togglePlay();
      });
    } else if (this.service.name === 'apple-music') {
      if (apiPlayer.isPlaying) {  
        apiPlayer.pause();
      } else {
        if (this.user_interacted) {
          apiPlayer.play();
        }
      }
    } else if (this.service.name === 'tidal') {
      if (apiPlayer.paused) {  
        apiPlayer.play();
      } else {
        apiPlayer.pause();
      }
    } else if (this.service.name === 'soundcloud') {
      apiPlayer.isPaused(scState);
      function scState(isPaused) {
        if (isPaused) { 
          apiPlayer.play();
        } else {
          apiPlayer.pause();
        }
        apiPlayer.getCurrentSound(getSoundCloudTrack);
      }
    } else if (this.service.name === 'youtube') {
      if (apiPlayer.getPlayerState() === 1) {
        apiPlayer.pauseVideo();
      } else {
        apiPlayer.playVideo();
      }
    } else if (this.service.name === 'deezer') {
      if (DZ.player.playing) {
        DZ.player.pause();
      } else {
        DZ.player.play();
      }
    }
  }

  seekPrev() {
    if (this.service.name === 'sonikit' || this.service === 'qobuz') {
      const currentIndex = this.tracklist.findIndex(x => x.id === this.currentTrack.id);
      if (!currentIndex) return;

      const targetIndex = currentIndex - 1;
      if (this.tracklist[targetIndex]) {
        apiPlayer.src = this.tracklist[targetIndex].source;
        this.updateTrack(this.tracklist[targetIndex]);
      }
    } else if (this.service.name === 'spotify') {
      apiPlayer.previousTrack().then(() => {
        //console.log('Set to previous track.');
      });
    } else if (this.service.name === 'apple-music') {
      apiPlayer.pause();
      apiPlayer.skipToPreviousItem();
    } else if (this.service.name === 'tidal') {
      tidal.changeTrack(this, 'prev');
    } else if (this.service.name === 'soundcloud') {
      apiPlayer.prev();
      apiPlayer.seekTo(0);
      apiPlayer.getCurrentSound(getSoundCloudTrack);
    } else if (this.service.name === 'youtube') {
      apiPlayer.previousVideo();
    } else if (this.service.name === 'deezer') {
      DZ.player.prev();
    }
  }

  seekNext() {
    if (this.service.name === 'sonikit' || this.service.name === 'qobuz') {
      const currentIndex = this.tracklist.findIndex(x => x.id === this.currentTrack.id);
      if (!currentIndex) return;

      const targetIndex = currentIndex + 1;
      if (this.tracklist[targetIndex]) {
        apiPlayer.src = this.tracklist[targetIndex].source;
        this.updateTrack(this.tracklist[targetIndex]);
      }
    } else if (this.service.name === 'spotify') {  
      apiPlayer.nextTrack().then(() => {
        //console.log('Skipped to next track.');
      });
    } else if (this.service.name ===  'apple-music') {
      apiPlayer.pause();
      apiPlayer.skipToNextItem();
    } else if (this.service.name === 'tidal') {
      tidal.changeTrack(this, 'next');
    } else if (this.service.name === 'soundcloud') {
      apiPlayer.next();
      apiPlayer.seekTo(0);
      apiPlayer.getCurrentSound(getSoundCloudTrack);
    } else if (this.service.name === 'youtube') {
      apiPlayer.nextVideo();
    } else if (this.service.name === 'deezer') {
      DZ.player.next();
    }
  }

  seekTo(time) {
    if (this.service.name === 'sonikit' || this.service.name === 'qobuz') {

    } else if (this.service.name === 'spotify') {  
      apiPlayer.seek(time).then(() => {
        apiPlayer.getCurrentState().then(state => {
          if (!state) {
            // console.log('No Spotify playback state')
            return
          }
        });
      });
    } else if (this.service.name === 'apple-music') {
      // convert ms to seconds
      apiPlayer.seekToTime( time / 1000 )
    } else if (this.service.name === 'tidal') {
      // convert ms to seconds
      apiPlayer.currentTime = time / 1000;
      apiPlayer.play();
    }
  }

  

  async queueMedia(track_index, current_time) {
    this.track_change_method = 'queued';

    if (this.service.name === 'sonikit' || this.service.name === 'qobuz') {
    } else if (this.service.name === 'spotify') {
      await spotify.start(this, track_index, current_time);
    } else if (this.service.name === 'apple-music') {
      await apiPlayer.changeToMediaAtIndex(track_index)
    } else if (this.service.name === 'tidal') {
      tidal.queueTrack(this, track_index);
    }

    return { status: 'queued'}
  }

  async play(track_index, current_time) {
    if (this.patch.role === 'station_element') {
      const livestream = await getPlaybackPosition(this.patch, this.service)
      track_index = livestream.track_index
      current_time = livestream.current_time
    }

    if (this.service.name === 'sonikit' || this.service.name === 'qobuz') {
      apiPlayer.play();
    } else if (this.service.name === 'spotify' && apiPlayer) {
      apiPlayer.activateElement();
      await spotify.start(this, track_index, current_time);
    } else if (this.service.name === 'apple-music') {
      if (!apiPlayer.isPlaying) {
        if (this.user_interacted) {
          // await apiPlayer.setQueue({
          //   [this.service.media_type]: this.service.media_id,
          //   startPlaying: true,
          //   startTime: current_time / 1000 
          // });

          await apiPlayer.changeToMediaAtIndex(track_index);
          await apiPlayer.seekToTime(current_time / 1000); // convert to seconds
          await apiPlayer.play();
        }
      }
    } else if (this.service.name === 'soundcloud') {
      apiPlayer.isPaused(scState);
      function scState(isPaused) {
        if (isPaused) { 
          apiPlayer.play();
        }
        apiPlayer.getCurrentSound(getSoundCloudTrack);
      }
    } else if (this.service.name === 'youtube' && apiPlayer) {
      apiPlayer.unMute(); // Ensure the player isn't muted if the user previously muted something on YouTube
      apiPlayer.playVideo();
    } else if (sonikit.player.service.name === 'tidal') {
      apiPlayer.play();
    }

    this.startTimer();
  }

  async stopContinousPlay() {
    if (this.service.name === 'spotify') { 
      spotify.forceStop()
    }
  }

  async pause() {
    if (this.service.name === 'sonikit' || this.service.name === 'qobuz') {
      apiPlayer.pause();
    } else if (this.service.name === 'spotify') {  
      apiPlayer.pause();
    } else if (this.service.name === 'apple-music') {
      if (apiPlayer.isPlaying) {  
        apiPlayer.pause();
      }
    } else if (this.service.name === 'tidal') {
      apiPlayer.pause();
    } else if (this.service.name === 'soundcloud') {
      apiPlayer.isPaused(scState);
      function scState(isPaused) {
        apiPlayer.pause();
        apiPlayer.getCurrentSound(getSoundCloudTrack);
      }
    } else if (this.service.name === 'youtube') {
      if (apiPlayer.getPlayerState() === 1) {
        apiPlayer.pauseVideo();
      }
    } else if (this.service.name === 'deezer') {
      if (DZ.player.playing) {
        DZ.player.pause();
      }
    }
  }

  async resume() {
    if (this.service.name === 'sonikit' || this.service.name === 'qobuz') {
      apiPlayer.play();
    } else if (this.service.name === 'spotify') {  
      apiPlayer.resume();
    } else if (this.service.name === 'apple-music') {
      if (!apiPlayer.isPlaying) {  
        apiPlayer.play();
      }
    } 
  }

  async disconnect() {
    this.pause();

    if (this.service.name === 'spotify') {

      apiPlayer.getCurrentState().then(state => {
        if (!state) {
          return
        }
        apiPlayer.disconnect();
      });
    } else if (this.service.name === 'apple-music') {
      
    } else if (this.service.name === 'tidal') {
        
    }
  }

  async mute() {
    if (this.service.name === 'sonikit' || this.service.name === 'qobuz') {
      apiPlayer.volume = 0;
    } else if (this.service.name === 'spotify') {
      apiPlayer.setVolume(0)
    } else if (this.service.name === 'apple-music') {
      apiPlayer.mute();
    }
    this.muted = true;
  }
  async unmute() {
    if (this.service.name === 'sonikit' || this.service.name === 'qobuz') {
      apiPlayer.volume = 1;
    } else if (this.service.name === 'spotify') {
      apiPlayer.setVolume(1)
    } else if (this.service.name === 'apple-music') {
      apiPlayer.unmute();
    }
    this.muted = false;
  }
}

class StreamTimer {
  constructor() {
    this.elapsedTime = 0;
    this.interval = 1000;
    this.streamThreshold = 30000;
    this.loop = null;
    this.state = 'ready';
  } 

  start() {
    this.state = 'running';
    if (this.loop) {
      clearTimeout(this.loop);
    }
    this.elapsedTime = 0;
    this.count();
  }
  async count() {
    this.loop = setTimeout(() => {
      this.elapsedTime += this.interval;
      
      if (this.elapsedTime === this.streamThreshold) {
        if (sonikit.user) {
          events.create({
            category: 'stream',
            patch_id: sonikit.player.patch.id,
            service_id: sonikit.player.service.id,
            media_type: 'track',
            media_id: sonikit.player.currentTrack.id,
            fan_id: sonikit.user._id
          });
        }
        sonikit.emit('trackStreamed', { service: sonikit.player.service, id: sonikit.player.currentTrack.id });
      }
      this.count();
    }, this.interval);
  }
  pause() {
    this.state = 'paused';
    clearTimeout(this.loop);
  }
  resume() {
    if (this.state === 'paused') {
      this.state = 'running';
      this.count();
    }
  }
}

let streamTimer;

export const init = async (sonikit_config, patch, service) => {
  sonikit = sonikit_config;

  sonikit.player = new Player(service);
  streamTimer = new StreamTimer();
  sonikit.player.patch = patch;

  if (sonikit.user && sonikit.user.access_token) {
    sonikit.player.access_token = sonikit.user.access_token;
  }

  if (patch.role !== 'station_element') {
    const auth = document.querySelector(`sonikit-patch[patch-id="${patch._id}"]`);
    if (auth) auth.remove();
    const player = document.createElement('sonikit-player');
    document.body.appendChild(player);
  }

  if (service.name === 'spotify' && (sonikit.user.service_subscription === 'free' || sonikit.user.service_subscription === 'open') ) {
    // Add support for other services
    clearSessions()
    sonikit.emit('playerError', { message: 'Premium account required for audio playback' });
    return 
  }

  let playbackData;
  if (patch.role === 'station_element') {
    playbackData = await getPlaybackPosition(patch, service)
    if (playbackData.status === 'ended') return;
  } else {
    // Get album/playlist info and tracks
    playbackData = await loadTrackList(service);
  }

  if (patch.role === 'station_element') {
    sonikit.player.player_type = 'station'
  } else {
    sonikit.player.player_type = 'default'
  }

  if (playbackData && playbackData.tracks) {
    // Display the first track immediately
    sonikit.player.tracklist = playbackData.tracks;
    sonikit.player.updateTrack(sonikit.player.tracklist[0]);
  }

  document.addEventListener('click', () => {
    sonikit.player.user_interacted = true
  })
  
  loadApiPlayers(patch, service);
}

const initLocalAudio = () => {
  const source = sonikit.player.tracklist && sonikit.player.tracklist[0].source;
  const audio = new Audio(source);
  // audio.addEventListener('canplaythrough', () => console.log('can play') );
  // audio.addEventListener('error', () => console.log('error') );
  audio.addEventListener('pause', () => sonikit.player.setState('paused') );
  audio.addEventListener('play', () => sonikit.player.setState('playing') );
  audio.addEventListener('ended', () => sonikit.player.setState('ended') );

  return audio;
}

export const loadApiPlayers = async (patch, service) => {
  if (service.name === 'spotify') {
    const script = document.createElement('script');
    script.src = "https://sdk.scdn.co/spotify-player.js";
    document.head.appendChild(script);

    window.onSpotifyWebPlaybackSDKReady = async () => {
      apiPlayer = await spotify.init(patch, sonikit.player);
    }
  } else if (service.name === 'apple-music') {
    if (!window.MusicKit) {
      const script = document.createElement('script');
      script.src = "https://js-cdn.music.apple.com/musickit/v3/musickit.js";
      script.onerror = function() {
        console.log("Error loading apple music" + script.src);
      };
      document.head.appendChild(script);

      document.addEventListener('musickitloaded', async function() {
        apiPlayer = await appleMusic.init(sonikit, patch, sonikit.player)
        appleMusic.removeDialogs()
      })
    } else {
      apiPlayer = await appleMusic.init(sonikit, patch, sonikit.player)
      appleMusic.removeDialogs()
    }
  } else if (service.name === 'amazon-music') {
    // 
  } else if (service.name === 'tidal') {
    // apiPlayer = await tidal.init(patch, player);
  } else if (service.name === 'youtube') {
    const script = document.createElement('script');
    script.src = "https://www.youtube.com/iframe_api";
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(script, firstScriptTag);

    script.onload = () => {
      window.onYouTubeIframeAPIReady = async () => {
        apiPlayer = await youtube.init(sonikit, sonikit.player);
      }
    }
  } else if (service.name === 'qobuz') {
    apiPlayer = initLocalAudio();
  }
}

const loadTrackList = async (service) => {
  const response = await fetch(`${sonikit.base_url}/load-tracklist?service_id=${service.id}`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${service.project}`,
      'Content-Type': 'application/json'
    }
  })
  
  if (!response.ok) return console.log(response.status);
  const data = await response.json();
  return data;
}

const getPlaybackPosition = async (patch, service) => {
  const response = await fetch(`${sonikit.base_url}/stations/${patch.station}/get-playback-position?service=${service.id}`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${patch.project}`,
      'Content-Type': 'application/json'
    }
  })
  
  if (!response.ok) {
    return console.log(response.status)
  }

  const data = await response.json()
  
  return data;
}